import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

//点击添加按钮
export function addBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ currentDataKey: null, fileList: [], documentList: [], showModal: true, customFormSubmitting: false, componentType: 'Create', title: 'Add System Notification' });
  setTimeout(() => {
    pageComponent.formRef.current?.setFieldsValue({ 'Subject': '', 'Content': '', 'file': undefined });
  }, config.setTimeoutMilliSecond);
}

//点击编辑按钮
export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ currentDataKey: parameter.key, fileList: [], documentList: [], showModal: true, customFormSubmitting: false, componentType: 'Edit', title: 'Edit System Notification' });
  httpClient
    .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        //把处理后的数据赋值给表单
        pageComponent.setState({ documentList: data.data.DocumentList });
        pageComponent.formRef.current?.setFieldsValue(data.data);
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//点击编辑按钮
export function sendNotification({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ currentDataKey: parameter.key, sendNotificationShow: true, selectedRowKeys: [], selectedModuleId: 0, currentTitle: parameter.Subject }, () => {
    pageComponent.getCompanyData(0);
  });
}
